const payment = {
  autopay: 'AutoPay',
  payment_from_business_account: '{value} - Płatność z konta firmowego z białej listy VAT',
  payment_from_other_than_business_account: '{value} - Płatność z innego konta',
  fast_processing:
    'Najszybsza realizacja zamówienia dzięki automatycznej weryfikacji. ' +
    'Jeżeli chcesz dokonać opłaty z innego konta wybierz opcję „Płatność z innego konta”',
  not_so_fast_processing:
    'Czas realizacji zamówienia wydłużony do 3 dni roboczych. ' +
    'Po dokonaniu opłaty poprosimy Cię o dodatkową weryfikację tożsamości za pomocą konta prywatnego - ' +
    'na podany adres mailowy otrzymasz od nas link do weryfikacji.',
  payment_must_be_made_from_a_business_account:
    'Tylko przelew z konta firmowego weryfikuje tożsamość, inne sposoby płatności wymagają dodatkowej weryfikacji',
  debit_note: 'Nota księgowa',
  payment_processing_takes_up_to_several_business_days: '{value} - Realizacja do 7 dni roboczych',
  debit_note_will_be_sent: 'Nota księgowa zostanie wystawiona w przeciągu 24h.',
  you_will_be_redirected_to_the_payment_screen: 'Za chwilę zostaniesz przekierowany do AutoPay w celu opłacenia kaucji.',
}

export { payment }
